/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from './app.component.ngfactory';
import * as i4 from '@angular/common';
import * as i5 from '@angular/platform-browser';
import * as i6 from '@angular/common/http';
import * as i7 from '@angular/forms';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.AppComponentNgFactory]],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),
          i0.ɵmpd(5120,i0.LOCALE_ID,i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i4.NgLocalization,
              i4.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(4608,i0.Compiler,i0.Compiler,
              ([] as any[])),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,
              i0.IterableDiffers,i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,
              i0.ɵl,([] as any[])),i0.ɵmpd(4608,i5.DomSanitizer,i5.ɵe,[i4.DOCUMENT]),
          i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i5.DomSanitizer]),i0.ɵmpd(4608,
              i5.HAMMER_GESTURE_CONFIG,i5.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,
              i5.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i5.ɵDomEventsPlugin(p0_0),new i5.ɵKeyEventsPlugin(p1_0),
                    new i5.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i4.DOCUMENT,i4.DOCUMENT,i4.DOCUMENT,i5.HAMMER_GESTURE_CONFIG]),i0.ɵmpd(4608,
              i5.EventManager,i5.EventManager,[i5.EVENT_MANAGER_PLUGINS,i0.NgZone]),
          i0.ɵmpd(135680,i5.ɵDomSharedStylesHost,i5.ɵDomSharedStylesHost,[i4.DOCUMENT]),
          i0.ɵmpd(4608,i5.ɵDomRendererFactory2,i5.ɵDomRendererFactory2,[i5.EventManager,
              i5.ɵDomSharedStylesHost]),i0.ɵmpd(6144,i0.RendererFactory2,(null as any),
              [i5.ɵDomRendererFactory2]),i0.ɵmpd(6144,i5.ɵSharedStylesHost,(null as any),
              [i5.ɵDomSharedStylesHost]),i0.ɵmpd(4608,i0.Testability,i0.Testability,
              [i0.NgZone]),i0.ɵmpd(4608,i5.Meta,i5.Meta,[i4.DOCUMENT]),i0.ɵmpd(4608,
              i5.Title,i5.Title,[i4.DOCUMENT]),i0.ɵmpd(4608,i6.HttpXsrfTokenExtractor,
              i6.ɵg,[i4.DOCUMENT,i0.PLATFORM_ID,i6.ɵe]),i0.ɵmpd(4608,i6.ɵh,i6.ɵh,[i6.HttpXsrfTokenExtractor,
              i6.ɵf]),i0.ɵmpd(5120,i6.HTTP_INTERCEPTORS,(p0_0:any) => {
            return [p0_0];
          },[i6.ɵh]),i0.ɵmpd(4608,i6.ɵd,i6.ɵd,([] as any[])),i0.ɵmpd(6144,i6.XhrFactory,
              (null as any),[i6.ɵd]),i0.ɵmpd(4608,i6.HttpXhrBackend,i6.HttpXhrBackend,
              [i6.XhrFactory]),i0.ɵmpd(6144,i6.HttpBackend,(null as any),[i6.HttpXhrBackend]),
          i0.ɵmpd(5120,i6.HttpHandler,i6.ɵinterceptingHandler,[i6.HttpBackend,[2,i6.HTTP_INTERCEPTORS]]),
          i0.ɵmpd(4608,i6.HttpClient,i6.HttpClient,[i6.HttpHandler]),i0.ɵmpd(4608,
              i7.ɵi,i7.ɵi,([] as any[])),i0.ɵmpd(4608,i7.FormBuilder,i7.FormBuilder,
              ([] as any[])),i0.ɵmpd(512,i4.CommonModule,i4.CommonModule,([] as any[])),
          i0.ɵmpd(1024,i0.ErrorHandler,i5.ɵa,([] as any[])),i0.ɵmpd(1024,i0.APP_INITIALIZER,
              (p0_0:any,p0_1:any) => {
                return [i5.ɵc(p0_0,p0_1)];
              },[[2,i5.NgProbeToken],[2,i0.NgProbeToken]]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i5.BrowserModule,i5.BrowserModule,[[3,i5.BrowserModule]]),i0.ɵmpd(512,
              i6.HttpClientXsrfModule,i6.HttpClientXsrfModule,([] as any[])),i0.ɵmpd(512,
              i6.HttpClientModule,i6.HttpClientModule,([] as any[])),i0.ɵmpd(512,i7.ɵba,
              i7.ɵba,([] as any[])),i0.ɵmpd(512,i7.FormsModule,i7.FormsModule,([] as any[])),
          i0.ɵmpd(512,i7.ReactiveFormsModule,i7.ReactiveFormsModule,([] as any[])),
          i0.ɵmpd(512,i1.AppModule,i1.AppModule,([] as any[])),i0.ɵmpd(256,i6.ɵe,'XSRF-TOKEN',
              ([] as any[])),i0.ɵmpd(256,i6.ɵf,'X-XSRF-TOKEN',([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc3dhbnRkaGF5YWwvRGVza3RvcC9Qcm9qZWN0cy9zZW5pb3JKYWNrZXRzL3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9qYXN3YW50ZGhheWFsL0Rlc2t0b3AvUHJvamVjdHMvc2VuaW9ySmFja2V0cy9zcmMvYXBwL2FwcC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /Users/jaswantdhayal/Desktop/Projects/seniorJackets/src/$$_gendir/app/app.module.ngfactory.ts